
export const GpsSkeleton = () => {
    return null // @TODO
}
